/** =========================================================
 * Module: api.service.js
 * Communication between backend service
 =========================================================*/

(function () {
  'use strict';

  angular
    .module('app.utils')
    .factory('$api', ['$rootScope', '$http', '$translate', 'Notify', function ($rootScope, $http, $translate, Notify) {
      var factory = {};
      $rootScope.config = null;

      function getConfig() {
        return new Promise(function (resolve, reject) {
          if ($rootScope.config === null) {
            $http.get('config.json')
              .then(function (file) {
                $rootScope.config = angular.fromJson(file.data);

                initSentry();
                initSocket();

                resolve($rootScope.config);
              }, function (error) {
                Raven.captureException(error);

                reject(error);
              });
          } else {
            resolve($rootScope.config);
          }
        });
      }

      function initSentry() {
        var options = {
          environment: $rootScope.config.environment
        };

        Raven
          .config($rootScope.config.sentry_dsn, options)
          .install();
      }

      function initSocket() {
        if (!$rootScope.config.socket_url) {
          console.log('Socket url undefined');

          return;
        }

        $rootScope.socket = io($rootScope.config.socket_url, {
          transports: ['websocket'],
          rejectUnauthorized: false
        });

        $rootScope.socket.on('connect', function () {
          console.log('Socket connected');
        });

        $rootScope.socket.on('authenticated', function () {
          console.log('Socket authenticated');
        });

        $rootScope.socket.on('error', function (error) {
          Raven.captureException(error);
        });

        $rootScope.socket.on('event:App\\Events\\ModelChanged', function (event) {
          try {
            var config = $rootScope.activeTableConfig;
            var eventData = event.data.data;

            if (config && $rootScope.appConfig) {
              if (config.model === eventData.model) {
                var itemIndex = null;

                if (typeof config.items !== 'undefined' && Array.isArray(config.items)) {
                  for (var i = 0; i < config.items.length; i++) {
                    if (typeof config.items[i].id !== 'undefined'
                      && typeof config.items[i] !== 'undefined'
                      && config.items[i].id === eventData.id
                    ) {
                      itemIndex = i;

                      break;
                    }
                  }
                } else {
                  config.items = [];
                }

                if (eventData.action === 'add' || eventData.action === 'delete' || itemIndex !== null) {
                  if (eventData.action === 'delete' && itemIndex !== null) {
                    $rootScope.$applyAsync(function () {
                      config.items.splice(itemIndex, 1);
                    });

                    return;
                  }

                  var request = {
                    model: config.model,
                    data: config.getDataParams,
                    id: eventData.id
                  };

                  factory.getOne(request).then(function (response) {
                    $rootScope.$applyAsync(function () {
                      if (response.status) {
                        if (eventData.action === 'add') {
                          config.items.unshift(response.data);
                        } else {
                          config.items[itemIndex] = response.data;
                        }
                      }
                    });
                  });
                }
              }
            }
          } catch (error) {
            Raven.captureException(error);
          }
        });
      }

      function notify(type, message, responeError) {
        var outputMessage = $translate.instant(message);

        if (responeError) {
          outputMessage += ': ' + $translate.instant(responeError);
        }

        Notify.alert(outputMessage, {
          status: type === 'error' ? 'danger' : 'success',
          pos: 'bottom-right'
        });
      }

      function onSuccess(resolve, reject, response, notifications) {
        var errorMessage = 'Request error';
        var data;

        try {
          data = angular.fromJson(response.data);
        } catch (e) {
          errorMessage = errorMessage + ': ' + e.message;
        }

        if (data) {
          if (notifications) {
            if (notifications.success) {
              if (data.status === true) {
                notify('success', notifications.success);
              }
            }

            if (notifications.error) {
              var message = notifications.error;

              if (data.error === 'no_permission' && data.data) {
                message = $translate.instant('No permission') + ': ' + $translate.instant(data.data.model._replace().capitalize()) + ' -> ' + $translate.instant(data.data.level._replace().capitalize());

                notify('error', message);

                reject();
              }

              if (data.status === false) {
                notify('error', message);
              }
            }
          }
        } else {
          var error = new Error(errorMessage);

          notify('error', errorMessage);

          reject(error);
        }

        resolve(data);
      }

      function onError(reject, request, response, notifications) {
        var errorMessage = 'Request error';
        var data;

        try {
          data = angular.fromJson(response.data);
        } catch (e) {
          errorMessage = errorMessage + ': ' + e.message;
        }

        if (data && data.data && data.data.message) {
          errorMessage = errorMessage + ': ' + data.data.message;
        }

        if (response.status === -1) {
          errorMessage = errorMessage + ': Connection error';
        }

        if (response.status === 401) {
          errorMessage = 'Authentication error';
        }

        if (response.xhrStatus === 'abort') {
          reject(new Error('Request abort'));

          return;
        }

        var error = new Error(errorMessage);

        if (notifications && notifications.error) {
          var message = notifications.error;

          if (data && data.error === 'no_permission' && data.data) {
            message = $translate.instant('No permission') + ': ' + $translate.instant(data.data.model._replace().capitalize()) + ' -> ' + $translate.instant(data.data.level._replace().capitalize());
          }

          notify('error', message);
        }

        if (request.timeout && request.timeout.$$state && request.timeout.$$state.status === 1) {
          reject(error);

          return;
        }

        try {
          Raven.setTagsContext({ requestUrl: request.url });

          Raven.captureBreadcrumb({
            message: 'Request data',
            data: request
          });

          Raven.captureBreadcrumb({
            message: 'Response data',
            data: {
              status: response.status,
              data: data
            }
          });
        } catch (e) {
          console.log(e);
        }

        reject(error);
      }

      function get(attrs) {
        return new Promise(function (resolve, reject) {
          getConfig().then(function (config) {
            var request = {
              method: 'GET',
              url: config.server_url + attrs.path,
              withCredentials: true,
              timeout: attrs.canceller || 90000
            };

            $http(request).then(function (response) {
              onSuccess(resolve, reject, response, attrs.notifications);
            }, function (response) {
              onError(reject, request, response, attrs.notifications);
            });
          });
        });
      }

      function post(attrs) {
        return new Promise(function (resolve, reject) {
          getConfig().then(function (config) {
            var request = {
              method: 'POST',
              url: config.server_url + attrs.path,
              data: attrs.data,
              withCredentials: true,
              timeout: attrs.canceller || 90000
            };

            if (attrs.headers) {
              request.headers = attrs.headers;
            }

            $http(request).then(function (response) {
              onSuccess(resolve, reject, response, attrs.notifications);
            }, function (response) {
              onError(reject, request, response, attrs.notifications);
            });
          });
        });
      }

      factory.get = function (attrs) {
        var request = attrs;

        return get(request);
      };

      factory.post = function (attrs) {
        var request = attrs;

        return post(request);
      };

      factory.getAppConfig = function () {
        var request = {
          path: '/api/app_config',
          notifications: null
        };

        return get(request);
      };

      factory.login = function (credentials) {
        var request = {
          path: '/api/login',
          data: credentials,
          notifications: null
        };

        return post(request);
      };

      factory.logout = function () {
        var request = {
          path: '/api/logout',
          notifications: null
        };

        return get(request);
      };

      factory.triggerOne = function (attrs) {
        var request = {
          path: '/api/trigger_one/' + attrs.model + '/' + attrs.id,
          canceller: attrs.canceller,
          notifications: {
            success: null,
            error: 'Unable to trigger'
          }
        };

        return post(request);
      };

      factory.getOne = function (attrs) {
        var request = {
          path: '/api/get_one/' + attrs.model + '/' + attrs.id,
          data: attrs.data,
          canceller: attrs.canceller,
          notifications: {
            success: null,
            error: 'Unable to receive data'
          }
        };

        return post(request);
      };

      factory.getAll = function (attrs) {
        var request = {
          path: '/api/get_all/' + attrs.model,
          data: attrs.data,
          canceller: attrs.canceller,
          notifications: {
            success: null,
            error: 'Unable to receive data'
          }
        };

        return post(request);
      };

      factory.add = function (attrs) {
        var output = {};

        for (var item in attrs.data) {
          if ((typeof attrs.only !== 'undefined' && attrs.only.indexOf(item) === -1) || (typeof attrs.except !== 'undefined' && attrs.except.indexOf(item) !== -1)) {
            continue;
          }

          output[item] = attrs.data[item];
        }

        var request = {
          path: '/api/add/' + attrs.model,
          data: angular.toJson(output),
          canceller: attrs.canceller,
          notifications: {
            success: attrs.quiet ? null : 'Successfully added item',
            error: 'Unable to add item'
          }
        };

        return post(request);
      };

      factory.update = function (attrs) {
        var output = {};

        for (var item in attrs.data) {
          if (((typeof attrs.only !== 'undefined' && attrs.only.indexOf(item) === -1) || (typeof attrs.except !== 'undefined' && attrs.except.indexOf(item) !== -1))
            && item !== 'id'
          ) {
            continue;
          }

          output[item] = attrs.data[item];
        }

        var request = {
          path: '/api/update/' + attrs.model,
          data: angular.toJson(output),
          canceller: attrs.canceller,
          notifications: {
            success: attrs.quiet ? null : 'Successfully updated item',
            error: 'Unable to update item'
          }
        };

        return post(request);
      };

      factory.delete = function (attrs) {
        var request = {
          path: '/api/delete/' + attrs.model,
          data: attrs.data,
          canceller: attrs.canceller,
          notifications: {
            success: attrs.quiet ? null : 'Successfully deleted item',
            error: 'Unable to delete item'
          }
        };

        return post(request);
      };

      factory.resource = function (attrs) {
        var request = {
          path: '/api/resource/' + attrs.model,
          data: attrs.data,
          canceller: attrs.canceller,
          notifications: {
            success: null,
            error: 'Unable to receive data'
          }
        };

        return post(request);
      };

      factory.uploadFile = function (data) {
        var preparedData = new FormData();

        for (var item in data) {
          if (item) {
            preparedData.append(item, data[item]);
          }
        }

        var request = {
          path: '/api/file_input/save',
          data: preparedData,
          notifications: null,
          headers: {
            'Content-Type': undefined
          }
        };

        return post(request);
      };

      factory.initSocket = initSocket;

      return factory;
    }]);
})();
